import { cls } from 'src/utils/string'
import styles from './unstyledButton.module.scss'

/**
 * @param {React.ButtonHTMLAttributes<HTMLButtonElement>} props
 */
const UnstyledButton = ({ children, className: classNameProp, ...rest }) => {
  const className = cls(styles.unstyledButton, classNameProp)

  return (
    <button className={className} {...rest}>
      {children}
    </button>
  )
}

export default UnstyledButton
